import axios from 'axios'

import config from '../config'
import {
  axiosGetAuthHeaderInterceptor,
  axiosSetAllowCORSInterceptor
} from '../utils/common'
import { createBlog } from './blogApi/createBlog'
import { getBlogDetail } from './blogApi/getBlogDetail'
import { getBlogList } from './blogApi/getBlogList'
import { getBlogStatistics } from './blogApi/getBlogStatistics'
import { updateBlog } from './blogApi/updateBlog'
import { updateBlogStatus } from './blogApi/updateBlogStatus'
import { createCategory } from './categoryApi/createCategory'
import { getAllCategories } from './categoryApi/getAllCategories'
import { getCategoryDetail } from './categoryApi/getCategoryDetail'
import { getCategoryList } from './categoryApi/getCategoryList'
import { searchCategory } from './categoryApi/searchCategory'
import { updateCategory } from './categoryApi/updateCategory'
import { createCompany } from './companyApi/createCompany'
import { getCompanyDetail } from './companyApi/getCompanyDetail'
import { getCompanyList } from './companyApi/getCompanyList'
import { getCompanyStatistics } from './companyApi/getCompanyStatistics'
import { updateCompany } from './companyApi/updateCompany'
import { updateCompanyStatus } from './companyApi/updateCompanyStatus'
import { uploadFile } from './fileApi/uploadFile'
import { archiveProduct } from './productApi/archiveProduct'
import { createProduct } from './productApi/createProduct'
import { getCompanyProductList } from './productApi/getCompanyProductList'
import { getProductDetail } from './productApi/getProductDetail'
import { updateProduct } from './productApi/updateProduct'
import { getFrontendSetting } from './settingApi/getFrontendSetting'
import { updateFrontendSetting } from './settingApi/updateFrontendSetting'
import { searchUsers } from './userApi/searchUsers'

const axiosInstance = axios.create({
  baseURL: config.api.baseUrl,
  timeout: config.api.timeout
})

axiosInstance.interceptors.request.use(axiosGetAuthHeaderInterceptor)
axiosInstance.interceptors.request.use(axiosSetAllowCORSInterceptor)

// TODO: redo all type
export const categoryApi = {
  getCategoryList: getCategoryList(axiosInstance) as (...args: any[]) => any,
  getCategoryDetail: getCategoryDetail(axiosInstance) as (
    ...args: any[]
  ) => any,
  createCategory: createCategory(axiosInstance) as (...args: any[]) => any,
  updateCategory: updateCategory(axiosInstance) as (...args: any[]) => any,
  searchCategory: searchCategory(axiosInstance) as (...args: any[]) => any,
  getAllCategories: getAllCategories(axiosInstance) as (...args: any[]) => any
}

// TODO: redo all type
export const companyApi = {
  getCompanyStatistics: getCompanyStatistics(axiosInstance) as (
    ...args: any[]
  ) => any,
  getCompanyList: getCompanyList(axiosInstance) as (...args: any[]) => any,
  getCompanyDetail: getCompanyDetail(axiosInstance) as (...args: any[]) => any,
  createCompany: createCompany(axiosInstance) as (...args: any[]) => any,
  updateCompany: updateCompany(axiosInstance) as (...args: any[]) => any,
  updateCompanyStatus: updateCompanyStatus(axiosInstance) as (
    ...args: any[]
  ) => any
}

// TODO: redo all type
export const productApi = {
  getCompanyProductList: getCompanyProductList(axiosInstance) as (
    ...args: any[]
  ) => any,
  getProductDetail: getProductDetail(axiosInstance) as (...args: any[]) => any,
  createProduct: createProduct(axiosInstance) as (...args: any[]) => any,
  updateProduct: updateProduct(axiosInstance) as (...args: any[]) => any,
  archiveProduct: archiveProduct(axiosInstance) as (...args: any[]) => any
}

export const fileApi = {
  uploadFile: uploadFile(axiosInstance) as (...args: any[]) => any
}

export const settingApi = {
  getFrontendSetting: getFrontendSetting(axiosInstance) as (
    ...args: any[]
  ) => any,
  updateFrontendSetting: updateFrontendSetting(axiosInstance) as (
    ...args: any[]
  ) => any
}

export const userApi = {
  searchUsers: searchUsers(axiosInstance) as (...args: any[]) => any
}

export const blogApi = {
  getBlogList: getBlogList(axiosInstance) as (...args: any[]) => any,
  getBlogDetail: getBlogDetail(axiosInstance) as (...args: any[]) => any,
  getBlogStatistics: getBlogStatistics(axiosInstance) as (
    ...args: any[]
  ) => any,
  createBlog: createBlog(axiosInstance) as (...args: any[]) => any,
  updateBlog: updateBlog(axiosInstance) as (...args: any[]) => any,
  updateBlogStatus: updateBlogStatus(axiosInstance) as (...args: any[]) => any
}
